import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Search, Filter } from "lucide-react";

const ActionFilters = ({ filters, setFilters, organizations }) => {
  const handleStatusChange = (value) => {
    setFilters((prev) => ({ ...prev, status: value }));
  };

  const handleOrganizationChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      organizationId: value === "all" ? null : value,
    }));
  };

  const handleSearchChange = (e) => {
    setFilters((prev) => ({ ...prev, search: e.target.value }));
  };

  return (
    <div className="bg-background rounded-xl shadow-md p-6 sticky top-4">
      <div className="flex items-center gap-2 mb-6">
        <Filter className="w-5 h-5 text-blue-600" />
        <h2 className="text-lg font-bold text-foreground">Filter</h2>
      </div>

      {/* Search */}
      <div className="mb-6">
        <Label htmlFor="search" className="text-sm font-semibold text-foreground mb-2">
          Suche
        </Label>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input
            id="search"
            type="text"
            placeholder="Aktion oder Organisation..."
            value={filters.search}
            onChange={handleSearchChange}
            className="pl-10"
          />
        </div>
      </div>

      {/* Status Filter */}
      <div className="mb-6">
        <Label className="text-sm font-semibold text-foreground mb-3 block">
          Status
        </Label>
        <RadioGroup value={filters.status} onValueChange={handleStatusChange}>
          <div className="flex items-center space-x-2 mb-2">
            <RadioGroupItem value="all" id="status-all" />
            <Label htmlFor="status-all" className="cursor-pointer font-normal">
              Alle Aktionen
            </Label>
          </div>
          <div className="flex items-center space-x-2 mb-2">
            <RadioGroupItem value="active" id="status-active" />
            <Label htmlFor="status-active" className="cursor-pointer font-normal">
              Aktive Aktionen
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="upcoming" id="status-upcoming" />
            <Label htmlFor="status-upcoming" className="cursor-pointer font-normal">
              Demnächst
            </Label>
          </div>
        </RadioGroup>
      </div>

      {/* Organization Filter */}
      <div>
        <Label className="text-sm font-semibold text-foreground mb-3 block">
          Organisation
        </Label>
        <RadioGroup
          value={filters.organizationId || "all"}
          onValueChange={handleOrganizationChange}
        >
          <div className="flex items-center space-x-2 mb-2">
            <RadioGroupItem value="all" id="org-all" />
            <Label htmlFor="org-all" className="cursor-pointer font-normal">
              Alle Organisationen
            </Label>
          </div>
          {organizations.map((org) => (
            <div key={org.id} className="flex items-center space-x-2 mb-2">
              <RadioGroupItem value={org.id} id={`org-${org.id}`} />
              <Label
                htmlFor={`org-${org.id}`}
                className="cursor-pointer font-normal flex items-center gap-2"
              >
                {org.logoUrl && (
                  <img
                    src={org.logoUrl}
                    alt={org.name}
                    className="w-5 h-5 rounded-full object-cover"
                  />
                )}
                {org.name}
              </Label>
            </div>
          ))}
        </RadioGroup>
      </div>
    </div>
  );
};

export default ActionFilters;
